@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.contact-field {
  display: flex;
  align-items: center;
  > label {
    flex: 0 0 auto;
  }
  > input {
    // there is no other way to override the margin in Input component
    margin-top: @space-0 !important;
  }
}

.contact-name-field {
  .contact-field;
  > input {
    margin-left: 2px;
  }
}

.contact-label {
  font-size: 14px;
  margin-right: @space-8;
}
